import { jsx as _jsx } from "react/jsx-runtime";
import i18next from 'i18next';
import { Button } from '@famly/mf_input_button';
import { ModalTestAttributes } from './modal-test-attributes';
/**
 * The close button element to be used on modern famly modals.
 *
 * @param onClose callback called when the close button is clicked
 */
export const ModalCloseButton = ({ onClose }) => {
    return (_jsx(Button, { size: "compact", "data-e2e-id": ModalTestAttributes.xButtonE2eId, icon: "close", "aria-label": i18next.t($ => $.mf.modalsDialogs_modal.src.translations.json.closeButtonAriaLabel), onClick: () => onClose(), variant: "transparent", alignSelf: "center" }));
};
